/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ViolationCategoryModel {
    getFixupPrototypeFunction() { return ViolationCategoryModel.fixupPrototype; }

    static newInstance(model: Partial<ViolationCategoryModel>): ViolationCategoryModel {
        let obj = Object.assign(new ViolationCategoryModel(), model);
        ViolationCategoryModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ViolationCategoryModel>): ViolationCategoryModel {
        if (!model) return null;
        return ViolationCategoryModel.newInstance(<ViolationCategoryModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ViolationCategoryModel) {
        if (!obj) return;

        models.ViolationCategoryModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ViolationCategoryModel): boolean {
        Object.setPrototypeOf(obj, ViolationCategoryModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.utilization) {
            models.SummaryModel.fixupPrototype(this.utilization);
        }
        if (this.standards) {
            models.SummaryModel.fixupPrototype(this.standards);
        }
    }

    /**
     * Contains the category and the number of violations under Utilization
     */
    utilization: models.SummaryModel;

    /**
     * Contains the category and the number of violations under Standards
     */
    standards: models.SummaryModel;

}
